import React, {Component} from 'react';
import {
    Platform,
    StyleSheet,
    View,
    TouchableOpacity,
    KeyboardAvoidingView,
    ActivityIndicator, Linking,
    BackHandler,
} from 'react-native';
import {connect} from 'react-redux';
import HMActionBarSatia from '../../../customviews/HMActionBarSatia';
import {moderateScale} from '../../../tools/Scaling';
import Colors from '../../../tools/Colors';

import {typeExport} from '../../../redux/store/type';
import store from '../../../redux/store/index';
import i18n from '../../../I18n/i18n';
import HMIcon from '../../../customviews/HMIcon';
import WebView from '../../../importCalss/WebView/index';
import {GoLink} from '../../../tools/Tools1';
// import WebView from 'react-native-webview';

//import OfflineCacheWebView from 'react-native-offline-cache-webview';
let container = null;

class WebViewScreen extends Component {

    constructor(props) {
        super(props);
        container = this;

        let _params = props?.route?.params;
        let _item = _params ? _params.item : null;
        let item = props.route && props.route.params ? _item : props;
        this.state = {
            visible: true,
            scalesPageToFit: !(item?.noScalesPageToFit),
            loading: true,
            currentURL: 'url',
            urlText: 'url',
            title: '',
            canGoForward: false,
            canGoBack: false,
            incognito: false,
            config: {
                allowStorage: true,
                allowJavascript: true,
                allowCookies: true,
                allowLocation: true,
                allowCaching: true,
                defaultSearchEngine: 'google',
            },
        };

        if (Platform.OS === 'android') {
            BackHandler.addEventListener('hardwareBackPress', this.backListener.bind(this));
        }

    }

    backListener() {
        /**
         * this.onMainScreen and this.goBack are just examples,
         * you need to use your own implementation here.
         *
         * Typically you would use the navigator here to go to the last state.
         */

        if (this.state.showBack) {
            this.onBack();
            /**
             * When true is returned the event will not be bubbled up
             * & no other back action will execute
             */
            return true;
        }
        /**
         * Returning false will let the event to bubble up & let other event listeners
         * or the system's default back action to be executed.
         */
        return false;
    }

    hideSpinner() {
        setTimeout(function () {
            this.setState({visible: false});
        }.bind(this), 3000);

        // this.setState({visible: false});
    }

    componentWillReceiveProps(propss) {

    }

    showDialogUpdateApp() {
    }

    componentDidMount() {

    }

    componentWillUnmount() {
        if (Platform.OS === 'android') {
            BackHandler.removeEventListener('hardwareBackPress', this.backListener.bind(this));

        }
        //Tools._RemoveConnectivity()
    }

    toggleIncognito = () => {
        this.setState({
            incognito: !this.state.incognito,
        });
        this.reload();
    };

    get config() {
        const {incognito, config} = this.state;
        if (incognito) {
            return {
                ...config,
                allowStorage: false,
                allowCookies: false,
                allowLocation: false,
                allowCaching: false,
            };
        }
        return config;
    }

    onNavigationStateChange = (navState) => {
        this.setState({
            canGoBack: navState.canGoBack,
        });
    };

    onBack() {
        this.ref_webview?.goBack?.();
    }

    _onNavigationStateChange(webViewState) {
        let res = null;
        let _params = this.props.route?.params;
        let _item = _params ? _params?.item : null;
        //  let res = (webViewState.url).split("?");
        //   if (res && res.length > 0 && res[0] == this.props.route.params.item.link_url) {
        res = _item ? (webViewState.url).split(_item.link_url) : null;

        res = res?.indexOf('/');
        if (res < 1) {
            this.setState({
                showBack: false,
            });
        }
        else {

            this.setState({
                showBack: true,
            });
        }
    }

    renderHtml = (url) => {
        return `<iframe src=${url} width="540" height="450"></iframe>`;
    };

    render() {
        let _params = this.props?.route?.params;
        let _item = _params ? _params.item : null;
        let item = this.props.route && this.props.route.params ? _item : this.props;

        let token = store.getState().reducerSplashGetAllData.token;
        let tokenSatia = store.getState().reducerSplashSatiaScreen.token;

        let token_fb = store.getState().reducerSplashGetAllData.token_fb;
        let token_fb_Satia = store.getState().reducerSplashSatiaScreen.token_fb;

        let user = store.getState().reducerSplashGetAllData.user;
        let userSatia = store.getState().reducerSplashSatiaScreen.user;

        let url = item.external_url ? item.external_url : (item.link_url + `${(item.link_url).indexOf('?') > 0 ? '&' : '?'}token_fb=${token_fb_Satia}&token=${ tokenSatia}&lang=${i18n.locale}&AppToken=${userSatia && userSatia.customer ? userSatia.customer.AppToken : null}`);
        // let url=item.link_url + `${(item.link_url).split("?")?'':'?'}${userSatia && userSatia.customer ? userSatia.customer.AppToken : null}`;
        return (


            <KeyboardAvoidingView style={{flex: 1}} behavior={'padding'}
                                  enabled={Platform.OS === 'ios'}>

                {
                    this.props.route ?
                        <HMActionBarSatia
                            menu
                            props={this.props} statusBarTransparent
                            // text={i18n.t('ListNews.title')}
                            //text={i18n.t('ListNews.title')}
                            text={(item.name ? item.name : (item.title ? item.title : ''))}

                            back
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}

                        />
                        :
                        null
                }


                <View style={{flex: 1}}>

                    {
                        Platform.OS === 'web' ?
                            <View style={{flex: 1}}>
                                {
                                    this.state.loading === true ?
                                        <ActivityIndicator
                                            //   style={{position: "absolute", top: typeExport.HEIGHT / 2, left: typeExport.WIDTH / 2}}
                                            // style={{position: "absolute", top: 0}}
                                            size="large"
                                        />
                                        : null
                                }
                                <iframe src={url} width="100%" height="100%"
                                        loading="eager"
                                        onLoad={() => {
                                            this.setState({
                                                loading: false,
                                            });
                                        }}


                                >

                                </iframe>

                            </View>

                            :
                            <WebView
                                // style={{}}
                                ref={ref => this.ref_webview = ref}
                                style={{
                                    height: typeExport._HEIGHT,
                                    // width: typeExport._WIDTH,
                                    width: '100%',
                                    resizeMode: 'contain',
                                    flex: 1,
                                }}
                                // injectedJavaScript={`const meta = document.createElement('meta'); meta.setAttribute('content', 'width=${typeExport._WIDTH}, initial-scale=0.35, maximum-scale=0.35, user-scalable=2.0'); meta.setAttribute('name', 'viewport'); document.getElementsByTagName('head')[0].appendChild(meta); `}
                                onLoad={() => this.hideSpinner()}
                                source={{uri: url}}
                                // source={{uri: "http://www.zoodmarket.co"}}
                                useWebKit={true}
                                thirdPartyCookiesEnabled={true}
                                domStorageEnabled={true}
                                javaScriptEnabled={true}
                                geolocationEnabled={true}
                                sharedCookiesEnabled={true}

                                cacheEnabled={true}
                                allowFileAccess={true}
                                scalesPageToFit={this.state.scalesPageToFit}
                                //injectedJavaScript={`const meta = document.createElement('meta'); meta.setAttribute('content', 'width=width, initial-scale=0.5, maximum-scale=0.5, user-scalable=2.0'); meta.setAttribute('name', 'viewport'); document.getElementsByTagName('head')[0].appendChild(meta); `}

                                originWhitelist={['*']}
                                scrollEnabled={true}
                                onLinkPress={(evt, href) => {
                                    Linking.openURL(href);
                                }}
                                //   onNavigationStateChange={this._onNavigationStateChange.bind(this)}
                                onLoadProgress={e => {
                                    let {url} = e?.nativeEvent;
                                    if (url?.search('.mp4') >= 0 || url?.search('.pdf') >= 0 || url?.search('.mp3') >= 0 || url?.search('.xlsx') >= 0 || url?.search('.docx') >= 0) {
                                        GoLink(url);
                                    }
                                    else {
                                        let res = null;
                                        let _params = this.props.route?.params;
                                        let _item = _params ? _params?.item : null;
                                        //  let res = (webViewState.url).split("?");
                                        //   if (res && res.length > 0 && res[0] == this.props.route.params.item.link_url) {

                                        res = (url).split(_item?.link_url);
                                        var res1 = res?.indexOf('/');

                                        if (res?.length > 0) {
                                            res = res.filter(function (el) {
                                                return el !== '' && (el?.search('/')) >= 0;
                                            });
                                        }
                                        res = res?.length;

                                        this.setState({
                                            showBack: res >= 1,
                                        });

                                    }


                                }
                                }

                                //   onNavigationStateChange={this.onNavigationStateChange}
                                //  renderLoading={this.ActivityIndicatorLoadingView}
                                //   renderLoading={() => {return this.ActivityIndicatorLoadingView();}}
                            />

                    }


                    {
                        this.state.showBack && !(item?.noShowBack) ?


                            <TouchableOpacity
                                style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    right: 0,
                                    margin: moderateScale(10),
                                    width: moderateScale(48),
                                    height: moderateScale(48),
                                    backgroundColor: Colors.colorPrimary,
                                    borderRadius: moderateScale(24),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                disabled={this.state.canGoBack}
                                onPress={() => this.onBack()}
                            >
                                <HMIcon name={'arrow-left'}
                                        type={'Feather'}

                                        style={{fontSize: moderateScale(20), color: Colors.light}}/>

                            </TouchableOpacity>
                            :
                            null

                    }


                    {/*     <TouchableOpacity
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            margin: moderateScale(10),
                            width: moderateScale(48),
                            height: moderateScale(48),
                            backgroundColor: Colors.colorPrimary,
                            borderRadius: moderateScale(24),
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        //disabled={this.state.canGoBack}
                        onPress={() => this.setState({scalesPageToFit: !this.state.scalesPageToFit})}
                    >
                        <FontAwesome5_Solid name={this.state.scalesPageToFit ?   "search-minus":"search-plus"}
                                         style={{fontSize: moderateScale(20), color: Colors.light}}/>

                    </TouchableOpacity>*/}
                    {this.state.visible && Platform.OS !== 'web' && (
                        <ActivityIndicator
                            style={{position: 'absolute', top: typeExport.HEIGHT / 2, left: typeExport.WIDTH / 2}}
                            //   style={{}}
                            size="large"
                        />
                    )}
                </View>
            </KeyboardAvoidingView>

        );
    }

}

const mapStateToProps = state => {
    return {
        // data: state.reducerSplashGetAllData,
        // NoInternetDialogSet: state.reducerMenuScreen.NoInternetDialogSet,
        // showLoadingSet: state.reducerMenuScreen.showLoadingSet,
        // resultsSetCommentScreen: state.reducerMenuScreen.resultsSetCommentScreen,
        // token: state.reducerSplashGetAllData.token,
        // DataSplashScreen: state.reducerSplashGetAllData,

    };
};
const styles = StyleSheet.create({
    WebViewStyle: {
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        marginTop: 40,
    },
    ActivityIndicatorStyle: {
        flex: 1,
        justifyContent: 'center',
    },
});
const mapDispatchToProps = dispatch => {
    return {
        //    callServiceCommentScreen: (url, params, type, typeConnection, page, item_count, token) => dispatch(callWebserviceComment(url, params, type, typeConnection, page, item_count, token)),
        // callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WebViewScreen);
